import { ReactComponent as IconAuditTrail } from '@/assets/svgs/ActivityLog.svg'
import { ReactComponent as IconConfigure } from '@/assets/svgs/Configurations.svg'
import { ReactComponent as IconEclip } from '@/assets/svgs/Eclip.svg'
import { ReactComponent as IconDataDictionary } from '@/assets/svgs/SelectionYes.svg'
import { ReactComponent as IconApiConfig } from '@/assets/svgs/api_config.svg'
import { ReactComponent as ApprovalIcon } from '@/assets/svgs/approvals-icon.svg'
import { ReactComponent as IconDownArrow } from '@/assets/svgs/caret-down.svg'
import { ReactComponent as IconDataSetting } from '@/assets/svgs/data-setting.svg'
import { ReactComponent as IconDashboard } from '@/assets/svgs/icon-dasboard.svg'
import { ReactComponent as IconLicenseKey } from '@/assets/svgs/license_key.svg'
import { ReactComponent as IconPackage } from "@/assets/svgs/package-data-medium-outline.svg"
import { ReactComponent as IconReceiveData } from '@/assets/svgs/received-icon.svg'
import { ReactComponent as IconRecordTransfer } from '@/assets/svgs/record-transfer-icon.svg'
import { ReactComponent as IconShareData } from '@/assets/svgs/share-icon.svg'
import { ReactComponent as IconSubmittals } from '@/assets/svgs/submittals-icon.svg'
import { NavigationLink } from '@/components/NavigationLink/index'
import { useBuildex } from '@/hooks/use-buildex/index'
import { features, useFeature } from '@/hooks/use-feature/index'
import useStaticData from "@/hooks/use-static-data/index"
import { matchRoutes, useLocation } from '@/lib/router-dom/index'
import { getDexConfig } from '@/utils/get-dex-config'
import { getEnvAndDex } from '@/utils/get-env-and-dex'
import classname from 'classnames'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { DEX_TYPE, userRole } from '../../config/constants'
import { useTradex } from '@/hooks/use-tradex/index'
import { featureConstant } from '@/constants/configuration/feature'
import useSubmittalsVisibility from '@/hooks/use-submittals/useSubmittalsVisibility'

const Navigation = () => {
	const {currentPath } = useLocation();
	const [configVisible, setConfigVisible] = useState(false)
	const [expandDashboard, setExpandDashboard] = useState(true)

	const { dex } = getEnvAndDex();

	const user = useSelector(state => state.auth.user)
	const profile = useSelector(state => state.auth.profile)
	const dashboard= profile.dashboard
	const staticData = useStaticData();

	const orgData = staticData?.orgs?.find(org => org.orgId === user?.organizationId)

	const checkConfig = matchRoutes([{path: "/configuration/"}], currentPath);
	const isMasterDataUploadEnabled = useFeature(featureConstant.MASTER_DATA_UPLOAD);

	useEffect(() => {
		if (checkConfig) {
			setConfigVisible(true)
		}
	}, [])

	const configNavigationItemClass = classname({
		'navigation-item': true,
		'navigation-item__parent--active': checkConfig
	})

	function handleConfiguration() {
		setConfigVisible(!configVisible)
	}

	/*=================================================

		Dynamic Nested Dashboard

	/================================================*/

	const renderDashboardLinks = () => {
		return (
			<>
				{(!isMasterDataUploadEnabled || (isMasterDataUploadEnabled && (user.role?.some((role) => role.name === userRole.SUPER_ADMIN || role.name === userRole.OPS_USER)))) && <div className={configNavigationItemClass} onClick={() => setExpandDashboard(!expandDashboard)}>
					<div className="navigation-item__side__rectangle"></div>
					<div className="navigation-item__icon"><IconDashboard /></div>
					<div className="navigation-item__label">Dashboards</div>
					{
						dashboard?.length > 0 && (
							<div className={`navigation-item__toggle ${expandDashboard ? 'navigation-item__chevron--rotate' : ''}`}>
								<IconDownArrow />
							</div>
						)
					}
				</div>}
				{
					expandDashboard && (
						<div className="navigation__sub-items__cols" >
							<div className="navigation__sub-items__col ">
								{
									dashboard?.map(({ dashboard_title, id }) => {
										return <NavigationLink to={`/dashboard/${id}`} key={id} text={dashboard_title} />
									})
								}
							</div>
						</div>
					)
				}
				{
					(user.role?.some((role) => role.name === userRole.SUPER_ADMIN || role.name === userRole.OPS_USER)) && isMasterDataUploadEnabled && expandDashboard && (<>
						<hr className='navigation__sub-items__cols-top-border' />
						<div className="navigation__sub-items__cols" >
							<div className="navigation__sub-items__col ">
								{
									<NavigationLink to="/master-data-management" text={"Master Data Management"} />
								}
							</div>
						</div>
					</>)
				}
			</>
		)
	}

	/*=================================================
		MultiDex
	/================================================*/
	const { LogoComponent } = getDexConfig(dex);

	const isBuildex = useBuildex();
	const isTradex = useTradex();
	const isSupersetDashboard = useFeature(features.DASHBOARD);
	const isEmbedDashboard = useFeature(featureConstant.DASHBOARD_EMBEDDING)

	const { showSubmittals } = useSubmittalsVisibility();

	return (
		<div className="navigation">
			<div className="navigation__header">
				<LogoComponent /> <span className="navigation__header__text">| Pitstop</span>
			</div>
			<div className="navigation__items">
				<div className="navigation__items__cols">
					<div className="navigation__items__col">
						{isEmbedDashboard && dashboard ? renderDashboardLinks() : null}
						{isBuildex && isSupersetDashboard && !isEmbedDashboard ? <NavigationLink to="/dashboard" icon={<IconDashboard/>} text="Dashboards" onClick={() => window.dataLayer?.push({ event: 'navigation_dashboard_clicked' })}/> : null}
						<NavigationLink to="/shared-data" icon={<IconShareData/>} text="Shared Data" onClick={() => window.dataLayer?.push({ event: 'navigation_shared_data_clicked' })}/>
						<NavigationLink to="/received-data" icon={<IconReceiveData/>} text="Received Data" onClick={() => window.dataLayer?.push({ event: 'navigation_received_data_clicked' })}/>
						{showSubmittals && <NavigationLink to="/submittals" icon={<IconSubmittals/>} text="Submittals" onClick={() => window.dataLayer?.push({ event: 'navigation_submittals_clicked' })}/>}
						{isTradex && <NavigationLink to="/eclip" icon={<IconEclip/>} text="Package Sharing"/>}
						{isTradex && orgData?.newPackageSharingEnabled && (
							<NavigationLink to="/package" icon={<IconPackage/>} text="New Package Sharing"/>
						)}

						{(user.role?.some((role) => role.name === userRole.ETR_USER)) && (
							<NavigationLink to="/record-transfer" icon={<IconRecordTransfer/>} text={"E-Transferable Record"} onClick={() => window.dataLayer?.push({ event: 'navigation_record_transfer_clicked' })}/>
						)}

						{(profile?.makerCheckerRole === "CHECKER") && (
							<NavigationLink to="/approvals" icon={<ApprovalIcon/>} text="Approvals"/>
						)}

						{((user.role?.some((role) => role.name === userRole.SUPER_ADMIN || role.name === userRole.TECH_USER))) && (
							<NavigationLink to="/my-activities" icon={<IconAuditTrail/>} text="Activity Log" onClick={() => window.dataLayer?.push({ event: 'navigation_my_activities_clicked' })}/>
						)}

						<div className={configNavigationItemClass} onClick={() => handleConfiguration()}>
							<div className="navigation-item__side__rectangle"></div>
							<div className="navigation-item__icon"><IconConfigure /></div>
							<div className="navigation-item__label">Configuration</div>
							<div  className={`navigation-item__toggle ${configVisible ? 'navigation-item__chevron--rotate' : ''}`}>
								<IconDownArrow />
							</div>
						</div>
						{
							configVisible && (
								<div className="navigation__sub-items__cols" >
									<div className="navigation__sub-items__col ">
										<NavigationLink to="/configuration/api-configuration"  text="API Configuration" onClick={() => window.dataLayer?.push({ event: 'navigation_api_configuration_clicked' })}/>
										<NavigationLink to="/configuration/data-settings" text="Data Settings" onClick={() => window.dataLayer?.push({ event: 'navigation_data_settings_clicked' })}/>
										{isTradex &&
											<NavigationLink to="/configuration/license-keys" text="License Key" onClick={() => window.dataLayer?.push({ event: 'navigation_license_keys_clicked' })}/>
										}
									</div>
								</div>
							)
						}
						<NavigationLink to="/data-dictionary" icon={<IconDataDictionary/>} text="Data Dictionary" onClick={() => window.dataLayer?.push({ event: 'navigation_data_dictionary_clicked' })}/>

					</div>
				</div>
			</div>
		</div>
	)
}

export default Navigation
